import { gql } from '@apollo/client';

export const GET_UNSUPPORTED_POPUPS = gql`
  query getUnsupportedPopupConfigs {
    liveOps {
      unsupportedPopupConfigs(place: MAIN_MENU) {
        id
        key
        name
        enabled
        place
        targetSystemName
        popupType
        minimumDeviceVersion
        blockerReleaseVersion
        displayPolicy
        titleTexts
        bodyTexts
      }
    }
  }
`;

export const CREATE_UNSUPPORTED_POPUP = gql`
  mutation createUnsupportedPopup($input: UnsupportedPopupConfigInput!) {
    createUnsupportedPopupConfig(input: $input) {
      id
      key
      name
      enabled
      targetSystemName
      popupType
      minimumDeviceVersion
      blockerReleaseVersion
      displayPolicy
      titleTexts
      bodyTexts
    }
  }
`;

export const UPDATE_UNSUPPORTED_POPUP = gql`
  mutation updateUnsupportedPopup($input: UpdateUnsupportedPopupConfigInput!) {
    updateUnsupportedPopupConfig(input: $input) {
      id
      key
      name
      enabled
      targetSystemName
      popupType
      minimumDeviceVersion
      blockerReleaseVersion
      displayPolicy
      titleTexts
      bodyTexts
    }
  }
`;

export const DELETE_UNSUPPORTED_POPUP = gql`
  mutation deleteUnsupportedPopup($id: ID!) {
    deleteUnsupportedPopupConfig(id: $id)
  }
`;
